export default __webpack_public_path__ + "static/products-bd8c2431d77249aa592a6f4b889d5333.svg";